import { render, staticRenderFns } from "./VendorName.vue?vue&type=template&id=3b31d607"
import script from "./VendorName.vue?vue&type=script&lang=js"
export * from "./VendorName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports